import React from "react";
import { Grid } from "@mui/material";
import CommonCarouselComponent from "@/components/carousal/common_carousel";
import cssStyles from "./cms_renderer.module.scss";
import { SectionData, ComponentRenderProps } from "./index";
import Title from "./Title";

interface CustCarouselProps {
    sectionData: SectionData;
    props: ComponentRenderProps;
}

const CustCarousel = ({ sectionData, props }: CustCarouselProps): JSX.Element | null => {
    const panelClassName = "carousel";
    return (
        <>
            {sectionData.title && <Title sectionData={sectionData} props={props} />}
            <Grid container className={cssStyles[panelClassName + "Container"]}>
                <CommonCarouselComponent fullWidth={true} type="scrollable"
                    cards={sectionData.items?.map((item: any) => (
                        <Grid key={item.name} item>{item}</Grid>
                    ))} />
            </Grid>
        </>
    );
};

export default CustCarousel;
